class optDuzine {
    constructor(odtacke, dotacke) {
        this.odtacke = odtacke;
        this.dotacke = dotacke;
    }
}

export { optDuzine as default }